import Loader from "@components/Loader";
import { LOGIN, RESET_PASSWORD_CONFIRM } from "@constants/routes";
import ResetPasswordConfirmForm from "@easydev/reset_password_confirm/ResetPasswordConfirmForm";
import logo from "@images/shared/logo.png";
import resetPasswordConfirm from "@services/Core/Account/resetPasswordConfirm";
import resetPasswordValidate from "@validators/Security/Account/ResetPassword.validate";
import { ReactElement, useState } from "react";
import { generatePath, NavLink, useHistory, useParams } from "react-router-dom";

const ResetPassword = (): ReactElement => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const history = useHistory();
  const { token, uuid } = useParams<{ token: string; uuid: string }>();

  const handleResetPassword = (FormValues: Record<string, any>) => {
    setIsLoading(true);

    resetPasswordConfirm(token, uuid, FormValues.password)
      .then(async (result) => {
        history.push(generatePath(RESET_PASSWORD_CONFIRM));
      })
      .catch((error) => {
        setErrorMessage(error?.response?.data?.error);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">
              <img src={logo} alt="logo" />
            </h3>
          </div>
          {isLoading ? (
            <Loader isInsideThing />
          ) : (
            <ResetPasswordConfirmForm
              onSubmit={(FormValues) => {
                handleResetPassword(FormValues);
              }}
              validate={resetPasswordValidate}
              errorMessage={errorMessage}
            />
          )}

          <div className="account__have-account">
            <p>
              Remember your password? <NavLink to={LOGIN}>Login</NavLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
